import { render, staticRenderFns } from "./otpvarification.vue?vue&type=template&id=4c062016&scoped=true"
import script from "./otpvarification.vue?vue&type=script&lang=js"
export * from "./otpvarification.vue?vue&type=script&lang=js"
import style0 from "./otpvarification.vue?vue&type=style&index=0&id=4c062016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c062016",
  null
  
)

export default component.exports